import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import GameScreen from "@/pages/GameScreen";
import SettingsScreen from "@/pages/SettingsScreen";
import HowToPlay from "@/pages/HowToPlay";
import OnlineLobby from "@/pages/OnlineLobby";
import OnlineGameScreen from "@/pages/OnlineGameScreen";

function App() {
  return (
    <div className="App" lang="it">
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/game" element={<GameScreen />} />
            <Route path="/settings" element={<SettingsScreen />} />
            <Route path="/come-si-gioca" element={<HowToPlay />} />
            <Route path="/online" element={<OnlineLobby />} />
            <Route path="/online/game" element={<OnlineGameScreen />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" theme="dark" offset={200} containerAriaLabel="Notifiche" />
      </SettingsProvider>
    </div>
  );
}

export default App;
